import { BootstrapWrapper } from "./BootstrapWrapper";

export class BootstrapWrapperBootstrap4 implements BootstrapWrapper {
  showModal: (modalElement: HTMLElement) => void = (modalElement) => {
    jQuery(modalElement).modal("show");
  };

  hideModal: (modalElement: HTMLElement) => void = (modalElement) => {
    jQuery(modalElement).modal("hide");
  };
}
